// Member types for the "counterparty" side of a shared-inbox conversation — the
// person the client is talking to. Their messages render on the LEFT:
//   - Guest      — a guest on a platform (Airbnb, etc.) or guest smart number
//   - Homekeeper — a pro
//   - PhoneNumber — an anonymous inbound sender on a guest/pro smart number we
//                   haven't matched to a contact yet
//   - Unidentified — a platform sender whose role the backend couldn't identify
//                    (gotidy #8231); treated as an unknown incoming party
//
// Everyone else is "our" side and renders on the RIGHT: the client app user
// ('CustomerMember'), concierge (sent as the customer account), and the
// host/co-host TIDY connects to a platform as ('Host'/'CoHost'). New/unrecognized
// sender types default to our side, so host-style additions never regress to the
// left the way 'Host' did before #8231.
export const COUNTERPARTY_MEMBER_TYPES = [
  'Guest',
  'Homekeeper',
  'PhoneNumber',
  'Unidentified',
];

export function isCounterpartyMessage(
  fromMember: { type?: string } | null | undefined,
): boolean {
  return COUNTERPARTY_MEMBER_TYPES.includes(fromMember?.type as string);
}
